var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3, .cls-4 {\n        fill: none;\n        stroke: #3aaa35;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1 {\n        stroke-width: 6px;\n      }\n\n      .cls-2 {\n        fill: #3aaa35;\n        stroke: #1d1d1b;\n        stroke-width: 0.5px;\n      }\n\n      .cls-3 {\n        stroke-width: 4px;\n      }\n\n      .cls-4 {\n        stroke-width: 5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 516.52,
    y1: 343.54,
    x2: 516.51,
    y2: 258.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 559.3,
    y1: 344.35,
    x2: 513.51,
    y2: 344.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 559.3,
    y1: 341.35,
    x2: 559.3,
    y2: 377.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.61,380.68c-19.92,13.56-47.24-3.07-111.29-23.23-28-8.83-51.25-14.59-66-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.51,344.35s-93.41-18.17-137,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 147.44,
    y1: 342.84,
    x2: 147.71,
    y2: 399.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 165.9,
    y1: 349.75,
    x2: 166.29,
    y2: 399.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.71,399.4c0,8.42,18.83,6.61,18.58-.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 377.51,
    y1: 343.95,
    x2: 305.37,
    y2: 381.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 514.39,
    y1: 344.35,
    x2: 512.14,
    y2: 344.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 503.36,
    y1: 342.6,
    x2: 515.51,
    y2: 344.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 513.51,
    y1: 344.29,
    x2: 517.29,
    y2: 344.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.26,344.35s-1,42.71-.52,56.65-22.22,16.52-22.22,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 505.52,
    y1: 395.24,
    x2: 505.52,
    y2: 384.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 513.51,
    y1: 255.4,
    x2: 593.72,
    y2: 255.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "566.04 254.65 582.54 264.18 582.54 245.13 566.04 254.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "525.38 254.65 541.88 264.18 541.88 245.13 525.38 254.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "516.51 286.46 526.04 269.96 506.99 269.96 516.51 286.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "516.51 332.06 526.04 315.56 506.99 315.56 516.51 332.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "505.52 407.33 515.04 390.83 495.99 390.83 505.52 407.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "527.47 368.95 517.95 385.45 537 385.45 527.47 368.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "495.95 341.49 479.9 331.22 479.03 350.25 495.95 341.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "390.89 339.82 409 345.75 405.08 327.1 390.89 339.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "324.31 371.35 343.33 372.38 334.72 355.39 324.31 371.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "250.56 376.34 264.39 389.45 268.83 370.92 250.56 376.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.76 356.97 205.58 370.08 210.02 351.55 191.76 356.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.98 336.89 135.81 350 140.25 331.47 121.98 336.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "147.63 393.37 157.15 376.87 138.1 376.87 147.63 393.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.1 376.7 156.57 393.2 175.62 393.2 166.1 376.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.1 376.87 156.57 393.37 175.62 393.37 166.1 376.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "554.41 344.23 537.91 334.7 537.91 353.75 554.41 344.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "559.3 381.95 568.83 365.45 549.78 365.45 559.3 381.95"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 445,
    y1: 336.56,
    x2: 445,
    y2: 385.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 455.71,
    y1: 411.44,
    x2: 445,
    y2: 384.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 443.82,
    y1: 269.96,
    x2: 443.82,
    y2: 333.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 410.81,
    y1: 336.56,
    x2: 410.81,
    y2: 269.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 376.48,
    y1: 274.71,
    x2: 376.48,
    y2: 342.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 343.19,
    y1: 276.71,
    x2: 376.48,
    y2: 276.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "366.96 309.81 376.48 326.31 386.01 309.81 366.96 309.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "350.93 286.24 367.43 276.71 350.93 267.18 350.93 286.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "411.18 304.71 420.71 288.21 401.65 288.21 411.18 304.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "443.82 304.71 453.35 288.21 434.3 288.21 443.82 304.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "454.81 337.32 438.76 327.06 437.89 346.09 454.81 337.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "445 374.33 435.47 390.83 454.52 390.83 445 374.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "452.83 405.1 450 416.22 461.26 412.88 452.83 405.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 534.41,
    y1: 198.16,
    x2: 470.45,
    y2: 198.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.93,
    y1: 198.16,
    x2: 466.29,
    y2: 22.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 466.29,
    y1: 22.42,
    x2: 476.35,
    y2: 9.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.81,35.32l-21.68.26q-.06-8.44-.13-16.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 559.73,
    y1: 18.68,
    x2: 506.57,
    y2: 18.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M568.35,12.68c0,7.09-11.61,6-11.61,6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "475.13 -2.93 465.6 13.57 484.66 13.57 475.13 -2.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "568.54 4.06 562.55 13.57 574.53 13.57 568.54 4.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "515.74 34.92 525.26 40.91 525.26 28.93 515.74 34.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "509 22.58 503.01 32.1 514.99 32.1 509 22.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "537.91 18.74 528.39 12.75 528.39 24.73 537.91 18.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "558.55 18.74 549.04 12.75 549.04 24.73 558.55 18.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "468.58 18.44 459.06 24.43 469.86 29.61 468.58 18.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "468.39 90.89 458.86 107.39 477.92 107.39 468.39 90.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "471.32 187.16 461.8 203.66 480.85 203.66 471.32 187.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/стрелки 1 этажа_Монтажная область 1.0a3d6b77ae3d39cecf25813f6dbb475c.svg";
export { ForwardRef as ReactComponent };